import Headroom from 'headroom.js';

document.addEventListener('DOMContentLoaded', function (event) {
    const header = document.querySelector('.header');

    if (header) {
        let offset = header.clientHeight;

        const headroom = new Headroom(header, {
            // vertical offset in px before element is first unpinned
            offset: offset,
            // scroll tolerance in px before state changes
            tolerance: {
                up: 5,
                down: 0,
            },
        });
        headroom.init();
    }
});

const headerElement = document.querySelector('.header');

if (headerElement) {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

// We listen to the resize event
window.addEventListener('resize', () => {
    if (headerElement) {
        // We execute the same script as before
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
});
